/* eslint-disable import/no-relative-packages */

import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'react-native';

import AORTypes from '../../types';
import AppBadge from './AppBadge';
import { payPeriod } from '../../modules/payout';
import { sprintf } from '../../../vendor/sprintf-js/src/sprintf';
import { translate } from '../../locales/i18n';

function MyAppBadge(props) {
  const { data, stats } = props;

  if (data === null || stats === null) {
    return (
      <>
      </>
    );
  }

  let textThisMonth = '';
  stats.forEach((stat) => {
    if (stat.mnth === payPeriod) {
      if (textThisMonth !== '') {
        textThisMonth += '<br/>';
      }
      const value = sprintf('%.2f %s', stat.amount, stat.currency);
      textThisMonth += translate('publisher_app_this_month', { people: stat.users, value });
    }
  });

  let textLastMonth = '';
  stats.forEach((stat) => {
    if (stat.mnth === payPeriod - 1) {
      if (textLastMonth !== '') {
        textLastMonth += '<br/>';
      }
      const value = sprintf('%.2f %s', stat.amount, stat.currency);
      textLastMonth += translate('publisher_app_last_month', { people: stat.users, value });
    }
  });

  return (
    <>
      <AppBadge data={data} />
      <Text>{textThisMonth}</Text>
      <Text>{textLastMonth}</Text>
    </>
  );
}

MyAppBadge.defaultProps = {
  stats: [],
};

MyAppBadge.propTypes = {
  data: AORTypes.MyApp.isRequired,
  stats: PropTypes.array, // eslint-disable-line react/forbid-prop-types
};

export default MyAppBadge;
